var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pulish-page"},[_vm._m(0),_c('div',{staticClass:"main"},[_c('div',{staticClass:"top-box"},[_c('publish-input'),_c('publish-list',{ref:"publishListRef"})],1),_c('file-list',{ref:"fileListRef"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("大攻城狮们将会热心为您的需求提供友情支持！")])])
}]

export { render, staticRenderFns }